import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", {
      "data-name": "Group 2637",
      transform: "translate(-677 -355)"
    }, [
      _createElementVNode("circle", {
        cx: "10",
        cy: "10",
        r: "10",
        fill: "#0076bb",
        "data-name": "Ellipse 19",
        transform: "translate(677 355)"
      }),
      _createElementVNode("path", {
        fill: "#fff",
        stroke: "#fff",
        d: "M685.31 368.607a.66.66 0 0 1-.466-.193l-2.917-2.912a.658.658 0 1 1 .93-.932l2.452 2.448 5.834-5.826a.659.659 0 1 1 .931.932l-6.3 6.291a.66.66 0 0 1-.464.192Z",
        "data-name": "Path 1478"
      })
    ], -1)
  ])))
}
export default { render: render }